import { useQuery } from '@tanstack/react-query';
import {
  getWebAnalyticsReport,
  getGA4Properties,
  getEngagementBySource,
  getEngagementTrend,
  type WebAnalyticsFilters,
} from '../services/api/webAnalytics';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes

export function useWebAnalyticsReport(filters: WebAnalyticsFilters | null) {
  return useQuery({
    queryKey: ['web-analytics', 'report', filters],
    queryFn: () => getWebAnalyticsReport(filters!),
    enabled: !!filters?.from && !!filters?.to,
    staleTime: STALE_TIME,
  });
}

export function useGA4Properties() {
  return useQuery({
    queryKey: ['web-analytics', 'properties'],
    queryFn: getGA4Properties,
    staleTime: STALE_TIME,
  });
}

export function useEngagementTrend(enabled: boolean, months: number = 6) {
  return useQuery({
    queryKey: ['web-analytics', 'engagement-trend', months],
    queryFn: () => getEngagementTrend(months),
    enabled,
    staleTime: STALE_TIME,
  });
}

export function useEngagementBySource(
  from: string | null,
  to: string | null,
  source: string | null
) {
  return useQuery({
    queryKey: ['web-analytics', 'engagement', from, to, source],
    queryFn: () => getEngagementBySource(from!, to!, source!),
    enabled: !!from && !!to && !!source,
    staleTime: STALE_TIME,
  });
}
